import * as yup from 'yup';

export const validationSchema = yup.object({
    passwordcurrent: yup
            .string()
            .required('Current Password is required'),
    password: yup
        .string()
        .required()
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required()
        .oneOf([yup.ref('password'), null], 'Password not matched'), 
}).required();

export const initialValues = {
    passwordcurrent: "",
    password: "",
    passwordconfirm: "",
}